module.exports = __webpack_public_path__ + "static/media/card.329e3b54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/atlanta/card.jpg
// module id = 881
// module chunks = 27